/* eslint-disable import/prefer-default-export */
import React from 'react';
import { apiGetSMSupplierList, apiGetSMFactoryList, ProductApi } from 'api';
import { ENTITIES } from 'views/DocumentManagement/components/SaveToModal/constants';

const getApiResponse = (tKey, params) => {
  switch (tKey) {
    case ENTITIES.SUPPLIER:
      return apiGetSMSupplierList(params);
    case ENTITIES.FACTORY:
      return apiGetSMFactoryList(params);
    default:
      return ProductApi.getListProduct(params, true);
  }
};

export const useEntityActions = (tKey) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [metaData, setMetaData] = React.useState([]);
  const loadData = async (tPage, tSearch, cb, willSetLoading) => {
    try {
      if (willSetLoading) setIsLoading(true);
      const res = await getApiResponse(tKey, {
        pageSize: 10,
        pageNo: tPage || 1,
        keywords: tSearch || '',
        searchBy: 'all',
      });
      const tList = res?.data?.data?.list || [];
      if (tPage > 1) {
        setList([...list, ...tList]);
      } else {
        setList(tList);
      }
      setMetaData(res?.data?.data?.pagination || {});
      if (willSetLoading) setIsLoading(false);
      if (cb) cb();
    } catch (error) {
      if (willSetLoading) setIsLoading(false);
      if (cb) cb();
    }
  };
  React.useEffect(() => {
    loadData(1, '', null, true);
  }, []);

  return {
    list,
    metaData,
    isLoading,
    refetch: loadData,
  };
};
